/*
    Controller for the Calendar Filter Panel component
 */

import angular from "angular";
import kendo from "@progress/kendo-ui";
import "kendo.timezones";

import ngSanitize from "angular-sanitize";
import ngAnimate from "angular-animate";
import ngAria from "angular-aria";
import uiBootstrap from "angular-ui-bootstrap";
import kendoDirectivesModule from "../../shims/kendoDirectives";

import Assert from "tbAssert";

import EventFilterPanelComponentModule from "../../views/event-filter-panel/EventFilterPanel";
import EventFilterStoreServiceModule from "../../services/EventFilterStoreService";

const calendarFilterPanelRootElementId = "tb-calendar-filter-panel-root";

const mScopeSvc = new WeakMap();
const mLogSvc = new WeakMap();

const mFilterPanelInitialized = new WeakMap();
const mDisplayFilterPanel = new WeakMap();

const mApplyCalendarFilterFn = new WeakMap();
const mAdditionalPanelClasses = new WeakMap();

const mEventFilterStoreSvc = new WeakMap();

class CalendarFilterPanelController {
    constructor($scope, $log, EventFilterStore) {
        Assert.StrictAssert($scope != null, "Assertion Failure: Missing Scope Service Dependency");
        Assert.StrictAssert($log != null, "Assertion Failure: Missing Log Service Dependency");
        Assert.StrictAssert(EventFilterStore != null, "Assertion Failure: Missing Event Filter Store Service Dependency");

        mScopeSvc.set(this, $scope);
        mLogSvc.set(this, $log);
        mEventFilterStoreSvc.set(this, EventFilterStore);

        mFilterPanelInitialized.set(this, false);

        mScopeSvc.get(this).$on(
            "$destroy",
            () => {
                mLogSvc.get(this).debug("Calendar Filter Panel: Destroy");

                let tbCalendarFilterPanelRootElement =
                    angular.element(`#${calendarFilterPanelRootElementId}`);

                kendo.destroy(tbCalendarFilterPanelRootElement);
            }
        );
    }

    get applyCalendarFilterFn() {
        return mApplyCalendarFilterFn.get(this);
    }

    set applyCalendarFilterFn(updatedVal) {
        mApplyCalendarFilterFn.set(this, updatedVal);
    }

    get additionalPanelClasses() {
        return mAdditionalPanelClasses.get(this);
    }

    set additionalPanelClasses(updatedVal) {
        mAdditionalPanelClasses.set(this, updatedVal);
    }

    get filterPanelInitialized() {
        return mFilterPanelInitialized.get(this);
    }

    set filterPanelInitialized(updatedVal) {
        mFilterPanelInitialized.set(this, updatedVal);
    }

    get displayFilterPanel() {
        return mDisplayFilterPanel.get(this);
    }

    set displayFilterPanel(updatedVal) {
        mDisplayFilterPanel.set(this, updatedVal);
    }

    hideFilterPanel() {
        this.displayFilterPanel = false;
    }

    applyEventFilter() {
        mLogSvc.get(this).debug("Calendar Filter Panel: Apply Calendar Filter");
        this.applyCalendarFilterFn();
        this.hideFilterPanel();
    }

    get eventFilterData() {
        return mEventFilterStoreSvc.get(this).calendarEventFilter;
    }

    saveEventFilterData() {
        mEventFilterStoreSvc.get(this).saveCalendarEventFilter();
    }

}

CalendarFilterPanelController.$inject = [ "$scope", "$log", "EventFilterStore" ];

CalendarFilterPanelController.dependencies = [
    ngSanitize,
    ngAnimate,
    ngAria,
    uiBootstrap,
    kendoDirectivesModule,
    EventFilterPanelComponentModule,
    EventFilterStoreServiceModule
];

CalendarFilterPanelController.template = require("./CalendarFilterPanel.tpl.html");

CalendarFilterPanelController.controllerAs = "calendarFilterPanel";

export default CalendarFilterPanelController;



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-calendar-view/CalendarFilterPanelController.js
// module id = VPRG
// module chunks = 1